import React, {useState} from 'react';
import {Iterable} from 'immutable';

import {DropdownItem, IconButton} from '@albert-io/atomic';
import {ANNOTATION_SHIELD_EXEMPT_PROPS} from 'client/components/PracticeView/Annotations/annotationFreeze';
import {SUPPLEMENT_CARD_PROPS} from 'client/components/PracticeView/Annotations/supplementCard';
import {NestedMarkdown} from 'generic/MarkdownRendererV2/NestedMarkdown.react';

import './free-form.scss';

interface FreeFormProps {
  content: any;
  name: string;
}

const FreeForm = ({content, name}: FreeFormProps) => {
  const [isHidden, setIsHidden] = useState(true);
  const freeFormContent = Iterable.isIterable(content) ? content.toJS() : content;

  let freeFormText = freeFormContent.text;
  if (!freeFormText) {
    freeFormText = 'No content entered.';
  }

  return (
    <div
      {...SUPPLEMENT_CARD_PROPS}
      className='rounded-x1 border-border-primary background-primary border border-solid'
    >
      <DropdownItem
        as='button'
        bold={false}
        onClick={(e) => {
          e.stopPropagation();
          setIsHidden(!isHidden);
        }}
        className='free-form__dropdown-item rounded-x1 p-x1'
        data-testid='free-form__expandable-item'
      >
        {/* Only the control is shield-exempt: it must still open the document under the
            annotation freeze, while the header stays a surface the student can mark. */}
        <IconButton
          {...ANNOTATION_SHIELD_EXEMPT_PROPS}
          as='div'
          size='s'
          aria-hidden
          icon={isHidden ? 'chevron-right' : 'chevron-down'}
          tooltip={isHidden ? 'Expand' : 'Collapse'}
          tooltipProps={{placement: 'top'}}
        />
        <NestedMarkdown className='ml-x2 py-x1 text-wrap' text={name} />
      </DropdownItem>
      {!isHidden && (
        <div className='px-x2 pt-x1 pb-x2'>
          <NestedMarkdown text={freeFormText} data-testid='free-form__markdown-renderer' />
        </div>
      )}
    </div>
  );
};

export default FreeForm;
